import React, { FC } from "react";
import "./CancelModal.scss";

interface CancelModal {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const DeleteModal: FC<CancelModal> = ({
  isOpen,
  onCancel,
  onConfirm,
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="list-modal-card">
        <h2>Are you sure you want to delete?</h2>
        <p>The operation cannot be reversed!</p>
        <div className="modal-actions">
          <button
            type="button"
            className="btn btn-cancel"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-confirm"
            onClick={onConfirm}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
